import { createSelector } from 'reselect'

import { getRangeFromDateFilter } from 'utils/dateUtils'
import permManager from 'utils/permManager'

import {
  selectActualFeatureFlags,
  selectActualLicenses,
  selectActualPermissions,
  selectPartner,
  selectSelfCompanyId,
} from 'containers/App/selectors'
import { selectCompanyFilter } from 'containers/PartnerOptions/selectors'

export const selectHasAccountInvestigationPermissions = createSelector(
  selectActualLicenses,
  selectActualFeatureFlags,
  selectActualPermissions,
  (licenses, ff, permissions) => permManager.check(permissions, ['admin', 'manage_irontraps'])
)
export const selectCompany = createSelector(
  selectCompanyFilter,
  selectSelfCompanyId,
  selectPartner,
  (companyFilter, selftCompanyId, partner) =>
    partner ? (companyFilter?.value ? [companyFilter.value] : null) : [selftCompanyId]
)

export const selectData = (state) => state.investigation.accountInvestigation.data
export const selectError = (state) => state.investigation.accountInvestigation.error
export const selectLoader = (state) => state.investigation.accountInvestigation.loader
export const selectArrivalDate = (state) => state.investigation.accountInvestigation.arrivalDate
export const selectPageNumber = (state) => state.investigation.accountInvestigation.pageNumber
export const selectTotalPages = (state) => state.investigation.accountInvestigation.totalPages
export const selectDepartments = (state) => state.investigation.accountInvestigation.departments
export const selectDepartmentsLoader = (state) =>
  state.investigation.accountInvestigation.departmentsLoader
export const selectSelectedDepartment = (state) =>
  state.investigation.accountInvestigation.selectedDepartment
export const selectEmailAddress = (state) => state.investigation.accountInvestigation.emailAddress
export const selectPermissionsError = (state) =>
  state.investigation.accountInvestigation.permissionsError
export const selectNoAddonsError = (state) => state.investigation.accountInvestigation.noAddonsError
export const selectAlertId = (state) => state.investigation.accountInvestigation.alertId

export const selectLicenseInfo = (state) => state.investigation.accountInvestigation.license
export const selectSelectedAddonsToUnlock = (state) =>
  state.investigation.accountInvestigation.selectedAddonsToUnlock
export const selectLicenseLoader = (state) => state.investigation.accountInvestigation.licenseLoader

export const selectDateRangeDummy = (state) => state.investigation.accountInvestigation.feDateRange

export const selectDateRange = createSelector(
  selectArrivalDate,
  selectDateRangeDummy,
  (dateFilter, dateRangeDummy) => dateRangeDummy || getRangeFromDateFilter(dateFilter)
)
